import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserAppsState } from './user-apps.reducer';

const selectFeature = createFeatureSelector<IUserAppsState>('userApps');

export const getRegisteredUserAppsActionState = createSelector(
  selectFeature,
  state => state.userRegisteredSaasResidentAppsActionState
);

export const getRegisteredUserApps = createSelector(
  selectFeature,
  state => state.userRegisteredSaasResidentApps
);

export const getSelectedCustomerIdent = createSelector(
  selectFeature,
  state => state.selectedCustomerIdent
);

export const getSelectedCustomerIdentActionState = createSelector(
  selectFeature,
  state => state.selectedCustomerIdentActionState
);
